import { UrlHelper } from '@getaccept/lib-shared-new/src/helpers/url.helper';
import ThemedButton from '@getaccept/lib-shared-new/src/components/ThemedButton.vue';
import { defineComponent } from 'vue';
import ProsemirrorViewerInput from './ProsemirrorViewerInput.vue';
import EditorNodeWrapper from './EditorNodeWrapper.vue';
export default defineComponent({
    name: 'EditorNodeLink',
    components: {
        ProsemirrorViewerInput,
        ThemedButton,
        EditorNodeWrapper,
    },
    props: {
        node: {
            type: Object,
            default: () => ({}),
        },
        mergeValues: { type: Object, default: () => ({}) },
        parentFirstChild: { type: Boolean, default: false },
        parentLastChild: { type: Boolean, default: false },
        blockWidthClass: { type: String, default: null },
        theme: { type: Object, default: () => ({}) },
    },
    emits: ['observe-node-visibility', 'node-click'],
    setup(props, { emit }) {
        const handleClick = () => {
            const url = UrlHelper.getHttpsUrl(props.node.linkUrl);
            window.open(url, '_blank');
            emit('node-click', { nodeId: props.node.id });
        };
        return {
            props,
            handleClick,
        };
    },
});
